import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class TopalService {
  url = environment.apiUrl + "/apps-connector";

  constructor(private http: HttpClient) {}

  getTopalConnection(): Observable<any> {
    return this.http.get<any>(this.url + "/topal/connection");
  }

  syncInvoice(invoiceId: string) {
    return this.http.post<any>(this.url + "/topal/sync-invoice/eva/" + invoiceId, {});
  }
}
